import React from 'react';
import {FieldValues, SubmitHandler} from 'react-hook-form';
import {useSearchParams} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import IOrderBy from 'shared/model/IOrderBy';
import {buildFiltersSearchParams, sortToUrlFilters} from 'shared/lib/filterHelper';

export interface IMonitorFiltersFormProps<T extends FieldValues> {
    onSubmit: SubmitHandler<T>,
    button: React.ReactElement,
}

type MonitorFiltersFormValues = FieldValues & {tags?: string[], orderBy?: IOrderBy};

interface IMonitorFiltersFormHandlerProps<T extends MonitorFiltersFormValues> {
    onSuccess: () => void,
    handleClose: () => void,
    FiltersForm: React.ComponentType<IMonitorFiltersFormProps<T>>,
    buildFilters: (_values: Omit<T, 'tags' | 'orderBy'>) => object,
    onApplied?: () => void,
}

function MonitorFiltersFormHandler<T extends MonitorFiltersFormValues>({
    onSuccess,
    handleClose,
    FiltersForm,
    buildFilters,
    onApplied,
}: IMonitorFiltersFormHandlerProps<T>) {
    const [searchParams, setSearchParams] = useSearchParams();

    const onSubmit: SubmitHandler<T> = ({tags, orderBy, ...rest}) => {
        const data = {
            ...sortToUrlFilters(orderBy),
            ...buildFilters(rest),
        };

        setSearchParams(buildFiltersSearchParams(searchParams, data, tags));
        onApplied?.();
        onSuccess();
    };

    return (
        <FiltersForm
            onSubmit={onSubmit}
            button={
                <ModalBlockButton
                    primaryButtonText={t`Применить фильтры`}
                    primaryButtonType="submit"
                    secondaryButtonOnClick={handleClose}
                />
            }
        />
    );
}

export default MonitorFiltersFormHandler;
